import { ConflictResolutionType, ExtendedIngredientDTO } from 'business/models/Models';
import React, { useState, useContext, useEffect } from 'react';
import IngredientsDetails from './IngredientsDetails';
import { StocksTable } from './stocksTable';
import cloneDeep from 'lodash/cloneDeep';
import { RMTableHeadingWithAddRemoveBtns } from 'components/customComponents/Controls/RMTableHeadingWithAddRemoveBtns';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { SubstituteIngredientProps } from '../IngredientsConstants';
import { substituteIngredientContext } from './IngredientsConflictsModel';
import { debounce, isEqual } from 'lodash';
import { FmlxRadioButton } from 'fmlx-common-ui';

const SubstituteIngredient = (props: SubstituteIngredientProps) => {
  const { matchedIngredients } = props;
  const {
    conflictResolutionType,
    setSelectedIngredient,
    onChangeIngredientType,
    selectedTypes,
    setSelectedTypes,
    selectedAliases,
    setSelectedAliases,
    selectedCasNumbers,
    setSelectedCasNumbers,
    selectedBufferData,
    setSelectedBufferData,
    setSelectedMatchedIngredient,
    selectedMatchedIngredient,
    onClickAddTypes,
    onClickAddAliases,
    onClickAddCasNumbers,
    onClickAddBufferData,
    onClickDeleteTypes,
    onClickDeleteAliases,
    onClickDeleteCasNumbers,
    selectedIds,
    setSelectedIds,
  } = useContext(substituteIngredientContext);
  const [matchedIngredient, setMatchedIngredient] =
    useState<ExtendedIngredientDTO[]>(matchedIngredients);
  const [searchText, setSearchText] = useState<string>('');

  useEffect(() => {
    if (matchedIngredients && !selectedMatchedIngredient) {
      setSelectedMatchedIngredient(cloneDeep(matchedIngredients[0]));
    }

    if (
      !isEqual(
        matchedIngredients?.filter((ing) =>
          ing.longName.toLowerCase().includes(searchText.toLowerCase()),
        ),
        matchedIngredient,
      )
    ) {
      setSearchText('');
      setMatchedIngredient(matchedIngredients);
    }
  }, [matchedIngredients, selectedMatchedIngredient]);

  const onChangeMatchedIng = (value: string) => {
    setSearchText(value);
    const tempMatchedIng = matchedIngredients.filter((ing) =>
      ing.longName.toLowerCase().includes(value.toLowerCase()),
    );
    setMatchedIngredient(tempMatchedIng);
  };
  const onClickDeleteStockBtn = () => {
    let isRemovable = true;
    const matchedIng = selectedMatchedIngredient;
    selectedIds.filter((index) => {
      if (selectedMatchedIngredient?.ingredientStock[index].id > 0) {
        isRemovable = false;
      } else {
        const stocks = matchedIng?.ingredientStock.filter((stock, i) => i !== index);
        matchedIng.ingredientStock = stocks;
        return index;
      }
    });

    if (!isRemovable) {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'You cannot remove existing stocks.',
      );
    } else {
      setSelectedIds([]);
      setSelectedMatchedIngredient(matchedIng);
    }
  };

  const debounceMatchedIngredient = debounce((item: ExtendedIngredientDTO) => {
    onChangeIngredientType(ConflictResolutionType.UseSubstitute, item);
  }, 500);
  return (
    <>
      <div
        id="substituteingredient-wrapper"
        className="flex-flow p-2 border-box existing-ingredient-box"
      >
        <FmlxRadioButton
          id="substituteingredient-usesubstitute-radiobutton"
          items={[
            {
              content: 'Use Substitute Ingredient',
              disabled: false,
              hint: '',
              type: 'information',
            },
          ]}
          onChange={() => onChangeIngredientType(ConflictResolutionType.UseSubstitute)}
          selectedIndex={
            conflictResolutionType === ConflictResolutionType.UseSubstitute ? 0 : -1
          }
        />
        <hr id="substituteingredient-divider-top" className="hr-line" />
        <h6 id="substituteingredient-existingingredients-title">
          <strong>Existing Ingredients</strong>
        </h6>
        <input
          id="substituteingredient-searchinput"
          className="search-ingredient-field"
          placeholder="Search Ingredient"
          onChange={(e) => onChangeMatchedIng(e.target.value)}
          value={searchText}
        />
        <div
          id="substituteingredient-existinglist-wrapper"
          className="wizard-list existing-ingredients-list pt-1"
        >
          {matchedIngredient?.map((item) => {
            const isSelected = selectedMatchedIngredient?.id === item.id;
            return (
              <div
                id={`substituteingredient-item-wrapper-${item.longName}`}
                key={`existing-ingredient-${item.id}`}
              >
                <button
                  id={`substituteingredient-item-button-${item.longName}`}
                  onClick={() => debounceMatchedIngredient(item)}
                  className={`existing-ingredient-list-item ${
                    isSelected ? 'border-primary border-2' : ''
                  }`}
                >
                  {item.longName}
                </button>
              </div>
            );
          })}
        </div>
        <IngredientsDetails
          conflictResolutionType={ConflictResolutionType.UseSubstitute}
          selectedIngredient={selectedMatchedIngredient}
          setSelectedIngredient={setSelectedIngredient}
          setSelectedTypes={setSelectedTypes}
          selectedTypes={selectedTypes}
          setSelectedAliases={setSelectedAliases}
          selectedAliases={selectedAliases}
          setSelectedCasNumbers={setSelectedCasNumbers}
          selectedCasNumbers={selectedCasNumbers}
          setSelectedBufferData={setSelectedBufferData}
          selectedBufferData={selectedBufferData}
          onClickAddTypes={onClickAddTypes}
          onClickAddAliases={onClickAddAliases}
          onClickAddCasNumbers={onClickAddCasNumbers}
          onClickAddBufferData={onClickAddBufferData}
          onClickDeleteTypes={onClickDeleteTypes}
          onClickDeleteAliases={onClickDeleteAliases}
          onClickDeleteCasNumbers={onClickDeleteCasNumbers}
        />
        <RMTableHeadingWithAddRemoveBtns
          tableHeading="Existing Stocks"
          onClickRemoveBtn={onClickDeleteStockBtn}
          showDeleteButton={true}
        />
        <StocksTable
          ingredientStocks={selectedMatchedIngredient?.ingredientStock}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
        ></StocksTable>
      </div>
    </>
  );
};
export default React.memo(SubstituteIngredient);
